import React from 'react'
import { Link as GatsbyLink } from 'gatsby'

const Link = ({ children, to, ...other }) => {
  const internal = /^\/(?!\/)/.test(to)

  // Use Gatsby Link for internal links, and <a> for others
  if (internal) {
    return (
      <GatsbyLink to={to} {...other}>
        {children}
      </GatsbyLink>
    )
  }
  return (
    <a href={to} {...other} target="_blank">
      {children}
    </a>
  )
}

export default Link
